import { ConfirmDialog } from "@/components/ui/dialogs";
import { useLanguage } from "@/contexts/LanguageContext";
import { LogOut } from "lucide-react";

interface LogoutConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function LogoutConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
}: LogoutConfirmDialogProps) {
  const { t } = useLanguage();

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      onConfirm={onConfirm}
      title={t("auth.logoutConfirm.title")}
      description={t("auth.logoutConfirm.description")}
      confirmText={t("auth.logoutConfirm.confirm")}
      cancelText={t("common.cancel")}
      variant="destructive"
      icon={<LogOut className="h-5 w-5" />}
    />
  );
}
